import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal } from "./Reveal";
import { useSiteContent } from "../../context/SiteContent";

export const Faq = () => {
  const { content } = useSiteContent();
  const faqs = content?.faqs || [];

  return (
    <section id="faq" className="py-24 md:py-32 bg-white" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <Reveal className="mb-12">
          <p className="overline text-helios-cyan mb-3">Engineering FAQ</p>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-helios-slate leading-[1.05]">
            Frequently Asked Engineering Questions
          </h2>
          <p className="mt-4 text-slate-600 text-lg leading-relaxed">
            Everything EPCs, plant managers, and O&amp;M contractors need to know about our robotic cleaning systems.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem key={f.id || i} value={`faq-${i}`}
                className="rounded-xl border border-helios-line bg-helios-mist px-5 data-[state=open]:border-helios-cyan/40 data-[state=open]:bg-helios-cyan/[0.03] transition-colors"
                data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display font-semibold text-helios-slate hover:no-underline py-5">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed text-[15px] pb-5">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
